module.exports = __webpack_public_path__ + "static/img/3-bai.811f616e.png";